import { cn } from "../../utils/class-names";
import { DashboardMarket } from "@silo/types";
import { StaticHealthFactor } from "../health-factor/static-health-factor";
import { BorrowingPowerUsed } from "../borrowing-power-used";
import {
  AtRiskOfLiquidationChip,
  DeprecatedChip,
  PausedChip,
} from "../alert-chip";

interface PositionMetaProps {
  className?: string;
  includeTitle?: boolean;
  market: DashboardMarket;
  isLoan: boolean;
}

export function PositionMeta({
  className,
  includeTitle,
  market,
  isLoan,
}: PositionMetaProps): JSX.Element {
  const {
    marketSymbol,
    healthFactor,
    borrowingPowerUsed,
    isDeprecated,
    isPaused,
    isAtRiskOfLiquidation,
  } = market;

  return (
    <div className={cn("flex flex-col gap-10", className)}>
      {includeTitle && (
        <div className="flex flex-wrap items-center justify-between gap-4">
          <h2 className="text-xl font-medium text-white">
            {marketSymbol} Silo
          </h2>

          <div className="flex items-center gap-2 overflow-x-auto">
            {isDeprecated && <DeprecatedChip />}
            {isPaused && <PausedChip />}
            {isAtRiskOfLiquidation && <AtRiskOfLiquidationChip />}
          </div>
        </div>
      )}

      {isLoan && (
        <div className="flex flex-col @screen-sm:flex-row gap-6 @screen-sm:gap-12">
          <div className="@screen-sm:flex-1">
            <StaticHealthFactor healthFactor={healthFactor} />
          </div>

          <div className="@screen-sm:flex-1">
            <BorrowingPowerUsed borrowingPowerUsed={borrowingPowerUsed} />
          </div>
        </div>
      )}
    </div>
  );
}
